// eslint-disable-next-line import/prefer-default-export
export const formatToKiloBytes = (bytes: number) =>
  `${Math.round(bytes / 1000)}KB`;
